import React, { Component } from "react";
import { Carousel, CarouselItem, Card, Button, Modal } from "react-bootstrap";
import { Navbar, Nav } from "react-bootstrap";
import { Link, NavLink, HashRouter } from "react-router-dom";
import Woman from "./pictures/woman-25Pro.jpg";
import Man from "./pictures/man-25.jpg";
import Relax from "./pictures/relaxing-25.jpg";
import Tools from "./pictures/tools-25.jpg";

class Slide extends React.Component {
  onClickAppointment = () => this.props.history.push("/appointment");
  onClickServices = () => this.props.history.push("/services");
  onClickAbout = () => this.props.history.push("/about");
  render() {
    // const sameCardHeightStyle = {
    //   height: "100%",
    // };

    const buttonBottomStyle = {
      alignSelf: "bottom",
    };
    return (
      <HashRouter>
        <div class="HomeCards">
          <div className="HomeCard">
            <Card className="centeredText">
              <Card.Header className="mainColor">Beratung</Card.Header>
              <Card.Body className="sameHeightCard">
                <Card.Img style={{ marginBottom: "30px" }} src={Woman} />
                <Card.Title>Sie im Fokus</Card.Title>
                <Card.Text style={{ marginTop: "10px" }}>
                  Mit{" "}
                  <span className="bold mainColor">
                    {" "}
                    individueller Typberatung
                  </span>{" "}
                  zur modischen Frisur
                </Card.Text>
                <div className="centerWrapper">
                  <p className="buttonBottomCentered">
                    <Button
                      className="mainColor"
                      variant="outline-primary"
                      onClick={this.onClickAppointment.bind(this)}
                    >
                      Termin vereinbaren
                    </Button>
                  </p>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="HomeCard">
            <Card className="centeredText">
              <Card.Header className="mainColor">Qualität</Card.Header>
              <Card.Body className="sameHeightCard">
                <Card.Img style={{ marginBottom: "30px" }} src={Tools} />
                <Card.Title className="centeredText">Handwerk</Card.Title>
                <Card.Text style={{ marginBottom: "10px" }}>
                  Ihre Frisur & Koloration{" "}
                  <span className="bold mainColor">aus Meisterhand</span>
                </Card.Text>
                <div className="centerWrapper">
                  <p className="buttonBottomCentered">
                    <Button
                      className="mainColor"
                      variant="outline-primary"
                      onClick={this.onClickServices.bind(this)}
                    >
                      Preise & Dienstleistungen
                    </Button>
                  </p>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="HomeCard">
            <Card className="centeredText">
              <Card.Header className="mainColor">Atmosphäre</Card.Header>
              <Card.Body className="sameHeightCard">
                <Card.Img style={{ marginBottom: "30px" }} src={Relax} />
                <Card.Title>Entspannung</Card.Title>
                <Card.Text style={{ marginTop: "10px" }}>
                  Genießen Sie Ihren Aufenthalt in{" "}
                  <span className="mainColor bold">ruhiger Umgebung</span>
                </Card.Text>
                <div className="centerWrapper">
                  <p className="buttonBottomCentered">
                    {/* <Button
                      className="mainColor"
                      variant="outline-primary"
                      onClick={this.onClickAbout.bind(this)}
                    >
                      Mehr erfahren
                    </Button> */}
                  </p>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </HashRouter>
    );
  }
}

export default Slide;
